var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTicketFooter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "682px",
    height: "166px",
    viewBox: "0 0 341 88",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CNC---Cuisine",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ticket",
    transform: "translate(-40.000000, -586.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bon-appetit",
    transform: "translate(-24.000000, 587.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.4296875,28.8242188 C24.3059456,42.0751584 123.271274,53.8570584 141.97928,47.661728 C170.041289,38.3687324 188.413647,2.50424908 184.105676,0.207723191 C179.797705,-2.0888027 159.255491,47.0909025 166.691557,45.1370923 C174.127623,43.1832821 169.935122,36.0881852 183.958465,33.4924718 C197.981809,30.8967584 200.29997,40.0503536 194.574068,45.1370923 C188.848166,50.223831 177.817746,35.4303033 193.955125,32.8775671 C210.092505,30.3248309 207.079333,42.6124566 205.453993,45.1370923 C203.828653,47.661728 203.301102,39.0508579 209.142474,34.8357852 C214.983847,30.6207125 198.916016,66.8027344 387.414062,34.8357852",
    id: "Path-17",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(123.951691, 38.366528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.524815066,4.54180971 C36.6768569,27.5004567 50.2963277,8.34033406 49.8322577,17.2366169 C49.6682251,20.3811426 50.5409496,28.1219733 41.6152627,27.8503353 C37.4931486,27.7248858 40.9344807,12.7543141 47.172611,14.3813873 C53.4107412,16.0084604 47.2323033,26.6499926 48.1571181,27.5004567 C50.9575891,30.0757835 58.0424121,19.9337125 57.855799,15.8376536 C57.6691859,11.7415947 59.476487,9.56904152 53.8168025,38.2161082 C48.1571181,66.8631749 54.8623283,13.8232345 61.521022,15.2029132 C68.1797158,16.5825919 63.3636209,30.7446852 56.7418667,28.2106827 C52.8216497,26.7105002 61.4278092,28.6628668 68.0732752,25.5268109 C72.652862,23.3656622 74.0022972,15.9066332 73.8662157,14.9208064 C73.5326653,12.5044402 74.6195086,10.799953 69.7560764,38.2161082 C64.8926442,65.6322634 69.9062972,13.525149 77.7815331,15.2029132 C85.6567689,16.8806774 77.7733243,30.7446852 72.7714372,28.2106827 C67.7695501,25.6766801 91.8817652,25.5091792 93.6083465,18.8590067 C95.3349279,12.2088341 89.0664251,12.5868132 87.1991999,17.5459977 C85.3319746,22.5051823 85.6660722,30.7242986 93.6083465,28.712359 C101.550621,26.7004194 105.242112,7.29290226 106.149183,1.21024931 C107.056254,-4.87240365 96.4110998,29.3041221 104.120245,29.3041221 C111.829389,29.3041221 114.44553,18.8846277 114.152202,16.6385174 C113.858875,14.3924071 110.887568,27.7423413 114.824228,28.712359 C118.760888,29.6823767 125.434084,15.5329562 126.546649,3.58005685 C127.659213,-8.37284246 109.966278,47.0533934 146.48579,23.6018364",
    id: "Path",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8384284,8.96134633 C91.5899884,8.96134633 93.2445149,8.69999346 95.8020079,8.17728771",
    id: "Path-24",
    strokeWidth: 2.39999986
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.986111,12.7749762 C113.620273,12.1024931 115.781373,11.1093338 116.240244,12.1024931 C116.546158,12.7645993 116.287946,13.2003404 115.465608,13.4097166",
    id: "Path-26",
    strokeWidth: 2.39999986
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTicketFooter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ticket-footer.032369a1493e5cb68bba334761d8670e.svg";